export const validate = (values) => {
  const errors = {}

  if (!values.uid) {
    errors.uid = 'Required'
  }

  return errors
}
